module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0 3